import * as React from 'react'

import { Text } from '@grandvisionhq/elements'
import {
  City,
  FormControl,
  FormGroup,
  HouseNumber,
  HouseNumberSuffix,
  PostalCode,
  Street as StreetInput,
} from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

import { FormProps } from '../types'
import NameField from './fields/NameField/NameField'
import TitleField from './fields/TitleField/TitleField'
import { isValidPostCode } from '~/components/validators'

type Props = {
  streetComponent?: React.ElementType
} & FormProps

export const AddressForm: React.FC<Props> = ({ streetComponent: Street = StreetInput }) => {
  const { getLabel, country } = useIntl()

  return (
    <React.Fragment>
      <TitleField />
      <NameField />
      <FormGroup columns={3}>
        <PostalCode
          label={getLabel('checkout.address.postalCode')}
          validations={[isValidPostCode]}
          errorMessage={getLabel('checkout.address.postalCode.errorMessage')}
          placeholder="1234"
        />
        <HouseNumber
          label={getLabel('checkout.address.streetNumber')}
          errorMessage={getLabel('checkout.address.streetNumber.errorMessage')}
        />
        <HouseNumberSuffix
          required={false}
          label={getLabel('checkout.address.streetNumber.suffix')}
          optionalText={getLabel('checkout.form.field.optional')}
        />
      </FormGroup>

      <Text className="legal-notice">{getLabel('checkout.address.legalNotice')}</Text>

      <FormGroup>
        <Street
          label={getLabel('checkout.address.addressLine')}
          errorMessage={getLabel('checkout.address.addressLine.errorMessage')}
        />
        <City
          label={getLabel('checkout.address.city')}
          errorMessage={getLabel('checkout.address.city.errorMessage')}
        />
        <FormControl
          required={false}
          optionalText=""
          id="country"
          label={getLabel('checkout.address.country')}
          initialState={{ value: country }}
          disabled
        />
      </FormGroup>
    </React.Fragment>
  )
}
export const CheckoutAddressForm = () => <AddressForm />
